// extracted by mini-css-extract-plugin
module.exports =  {"styledBlockquote":"CustomBlockquote-module__styledBlockquote--ptWcn","textWrapper":"CustomBlockquote-module__textWrapper--dB0J1"};